export default __webpack_public_path__ + "static/media/Etape4_Petits_carreaux_Bremandiere_After_Filtre.772d0540.jpg";